export default {
  computed: {
    fields() {
      return [
        {
          label: this.$t('global.field.fleetTaskNumber'),
          key: 'number',
          isRedirectable: true,
          hasOpenNewTab: true,
          isSortable: true,
          isLocked: true,
          tdAttr: {
            style: 'width:140px',
          },
          thAttr: {
            style: 'width:140px',
          },
        },
        {
          label: 'Status',
          key: 'status.name',
          isSortable: true,
          isLocked: true,
          ...(this.hasAutoEndedQuickAssignment && {
            tdAttr: {
              style: 'min-width:200px;max-width:200px;padding-right: 10px;',
            },
            thAttr: {
              style: 'min-width:200px;max-width:200px;padding-right: 10px;',
            },
          }),
        },
        {
          label: this.$t('global.field.licensePlate'),
          key: 'vehicle.license_plate',
          isSortable: true,
          isLocked: true,
        },
        {
          label: this.$t('global.field.driver'),
          key: 'driver.name',
          isSortable: false,
        },
        {
          label: this.$t('global.field.userGroup'),
          key: 'user_group.name',
          isSortable: false,
        },
        {
          label: this.$t('global.field.createdDate'),
          key: 'created_on',
        },
        {
          label: this.$t('fleetTaskInstant.field.targetStart'),
          key: 'expected_started_on',
          isSortable: false,
        },
        {
          label: this.$t('fleetTaskInstant.field.actualStart'),
          key: 'actual_started_on',
          isSortable: false,
        },
        {
          label: this.$t('fleetTaskInstant.field.routeTimeline'),
          key: 'timeline_route',
          tdAttr: {
            style: 'min-width:400px;max-width:400px',
          },
          thAttr: {
            style: 'min-width:400px;max-width:400px',
          },
        },
        {
          label: this.$t('fleetTaskInstant.field.currentInformation'),
          key: 'current_point_status',
        },
        {
          label: this.$t('global.field.location'),
          key: 'current_point_location',
          tdAttr: {
            style: 'max-width:400px',
          },
          thAttr: {
            style: 'max-width:400px',
          },
        },
        {
          label: this.$t('global.field.note'),
          key: 'note',
          tdClass: 'text-truncate',
          tdAttr: {
            style: 'max-width:248px',
          },
        },
        {
          label: this.$t('global.field.whatsappNumber'),
          key: 'phone_number',
        },
        {
          label: this.$t('global.field.tracking'),
          key: 'track_fo',
          isSortable: false,
          isLocked: true,
          isSticky: true,
          tdAttr: {
            style: 'right:-30px;position:sticky;border-left:1px solid #e6e7ec',
          },
          thAttr: {
            style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
          },
        },
      ]
    },
  },
}
